import React, { useContext, useState } from 'react'
// import FormContainer from './Add/Container';
import { CATEGORIES, CONTENT_TYPE, DATE_FORMAT_DISPLAY, INSTAGRAM, STATUS_AGENCY_REJECTED, STATUS_INFLUENCER_REJECTED } from '../../constants';
import { RxInstagramLogo } from "react-icons/rx";
import { MdPhone } from "react-icons/md";
import Actions from './Actions';
import { DateTime } from 'luxon';
import { HiCalendarDateRange, HiOutlineExclamationCircle } from "react-icons/hi2";
import { PiTiktokLogo } from 'react-icons/pi';
import { HiOutlineSparkles } from "react-icons/hi";
import FormattedCurrency from '../../components/FormattedCurrency';
import { FormattedMessage } from 'react-intl';

const Card = ({ item, refreshListing, data,fromAgency }) => {
    const [isHovered, setIsHovered] = useState(false);
    console.log("data", data);
    return (
        <div

            className='bg-white py-6   px-6 lg:px-4 rounded-2xl hover:transition-all duration-75 relative shadow-md min-h-[200px] border-[1px] w-full'>
             {data.status === STATUS_AGENCY_REJECTED.value && data.notes && (
                <div
                className="absolute top-0 right-0 m-6"
                onMouseEnter={() => setIsHovered(item.id)}
                onMouseLeave={() => setIsHovered(null)}
            >
                <HiOutlineExclamationCircle className="text-red-500 text-3xl cursor-pointer" />
                {isHovered === item.id && (
                    <div className="absolute top-8 right-0 w-64 bg-base-bg rounded-[10px] p-3 shadow-lg">
                        <h3 className="text-sm font-semibold text-t-dark mb-2"><FormattedMessage id="rejection_note" defaultMessage="Rejection Note" />:</h3>
                        <p className="text-xs text-t-light">{data.notes}</p>
                    </div>
                )}
            </div>
            )}
            <div className='flex items-center gap-x-3 flex-grow'>

                <div
                    className={`flex items-center justify-center w-12 h-12 rounded-xl bg-[#FAFAFA] bg-cover bg-center bg-no-repeat`}
                    style={{
                        backgroundImage: `url(${data?.campaign?.agency?.user?.picture ? data.campaign.agency.user.picture : ''})`
                    }}
                >
                    {
                        !data.campaign.agency.user.picture &&
                        <HiOutlineSparkles className='text-3xl text-primary' />
                    }
                </div>
                <div className='flex flex-col gap-y-'>
                    <h1 className='text-2xl font-bold text-t-dark'> {data.campaign?.agency?.company_name}</h1>
                    <p className='text-xs inline-flex space-x-3 items-center text-gray-500'>
                        <span className='inline-flex space-x-2'>
                            <MdPhone className='text-base' />
                            <span>{data.campaign?.agency?.contact_number}</span>
                        </span>
                        <span className='text-base'>•</span>
                        <span className='inline-flex space-x-2'>
                            <HiCalendarDateRange className='text-base' />
                            <span>{DateTime.fromISO(item?.release_dates[0]?.release_date).toFormat(DATE_FORMAT_DISPLAY)}</span>
                        </span>
                    </p>
                </div>
            </div>
            <div className='flex gap-x-2 my-5'>
                {
                    item.target_niche.map((niche, index) => (
                        <div key={index} className={`text-xs rounded-xl px-3 py-0.5 bg-[#FFEFEE] text-[#C57572]`}>
                                        {CATEGORIES.find(item => item.value === niche)?.label ? CATEGORIES.find(item => item.value === niche)?.label : niche}
                        
                        </div>
                    ))
                }

            </div>
            <div className='my-5 h-[40px] text-sm line-clamp-2'>
                {data.campaign?.project_description}
            </div>
            <div className='flex flex-col sm:flex-row gap-x-2 my-5 space-y-4 sm:space-y-0'>
                <div className='p-2 w-full   min-h-10 rounded-xl'>
                    <div className='text-xs text-[#A3A3A3]'><FormattedMessage id="budget" defaultMessage="Budget" /></div>
                    <div className='text-base'><FormattedCurrency value={item.budget} /></div>
                </div>
                <div className='p-2 w-full  min-h-10 rounded-xl'>
                    <div className='text-xs text-[#A3A3A3]'><FormattedMessage id="quantity" defaultMessage="Quantity" /></div>
                    <div className='text-base'>{item.quantity}</div>
                </div>
                <div className='p-2 w-full  min-h-10 rounded-xl'>
                    <div className='text-xs text-[#A3A3A3] capitalize'><FormattedMessage id="content" defaultMessage="Content" /></div>
                    <div className=' inline-flex space-x-1 items-center text-sm'>
                        {/* {CONTENT_TYPE.find((type) => type.value === item.content_type)?.platform === INSTAGRAM ? 
                        <RxInstagramLogo className='text-2xl' /> : <PiTiktokLogo className='text-2xl' />} */}
                     <span className=' capitalize'>{CONTENT_TYPE.find((type) => type.value === item.content_type)?.label}</span></div>
                </div>

            </div>
            <Actions data={data} item={item} fromAgency={fromAgency} refreshListing={refreshListing} />
        </div>
    )
}

export default Card;
